import React from 'react'
import PhoneField from './PhoneField'

function PhoneFieldWrapper({ defaultCountry, ...props }) {
  return <PhoneField {...props} defaultCountry={defaultCountry} />
}

export default PhoneFieldWrapper
